import { IEvent } from "~/activerequest/interfaces";
import { IAlternativePOIResponse } from "~/mymaps2/reviews/interfaces";
import { IEventPoiagg } from "~/interfaces";
import Dialog, { IDialogOptions } from "~/ui/dialog";
import { node } from "~/util/dom";
import { fetchAlternativePOIs } from "~/util/providers/review";
import POISelectItem from "~/ui/poiselectitem";
import { createDialogButton } from "./dialogbutton";
import { CONFIG } from "~/config";
import { _ } from "~/i18n";

interface IAlternativePOIDialog extends Partial<IDialogOptions> {
	onPOISelect: (selected: IEventPoiagg) => void;
	onClose: (data?: any) => void;
	onInvalidRequest: () => void;
	event: IEvent;
}

export default class AlternativePOIDialog {
	_onPOISelect: (selected: IEventPoiagg) => void;

	_onClose: (data?: any) => void;

	_onInvalidRequest: () => void;

	_event: IEvent;

	_selectItems: Array<POISelectItem>;

	_selectedPOI: IEventPoiagg;

	_dialog: Dialog;

	constructor({
		onClose,
		onInvalidRequest,
		onPOISelect,
		event,
		...args
	}: IAlternativePOIDialog) {
		this._dialog = new Dialog({
			...args,
			onClose,
		});
		this._onClose = onClose;
		this._onInvalidRequest = onInvalidRequest;
		this._onPOISelect = onPOISelect;
		this._event = event;
		this._selectItems = [];
		this._selectedPOI = null;
		this._dialog.dom.container.classList.add("ui-alternativePoiDialog");
	}

	destroy() {
		this._dialog.destroy();
		this._onClose = null;
		this._onInvalidRequest = null;
		this._onPOISelect = null;
		this._event = null;
		this._selectItems = [];
		this._selectedPOI = null;
	}

	async open() {
		this._dialog.open();

		// nadpis
		const date = new Date(this._event.time * 1000);
		const lang = CONFIG.defaultLang;

		this._dialog.dom.content.appendChild(node("h2", { className: "ui-alternativePoiDialog__title", innerHTML: _("mymap.reviews.alternative.title") }));
		this._dialog.dom.content.appendChild(node("p", {
			className: "ui-alternativePoiDialog__subtitle",
			innerHTML: _("mymap.reviews.alternative.time", {
				date: new Intl.DateTimeFormat(lang, { weekday: "long", year: "numeric", month: "long", day: "numeric" }).format(date),
				time: new Intl.DateTimeFormat(lang, { hour: "numeric", minute: "numeric" }).format(date),
			}),
		}));

		// loader
		Mapy.getComponent("loader").start();

		const loader = node("img", { src: "/img/loader.gif", width: 24, height: 24, className: "myreviews__loader" });

		this._dialog.dom.content.appendChild(loader);

		// neni to ani jeden
		const wrongPOI = node("div", { className: "ui-alternativePoiDialog__wrongPoi" });
		const wrongButton = node("button", { type: "button", innerHTML: _("mymap.reviews.alternative.wrongButton") });

		wrongButton.setAttribute("data-log-ignore", "true");
		wrongButton.addEventListener("click", () => {
			this._onInvalidRequest && this._onInvalidRequest();
		});
		wrongPOI.appendChild(wrongButton);
		wrongPOI.appendChild(node("p", { innerHTML: _("mymap.reviews.alternative.wrongText") }));
		this._dialog.dom.content.appendChild(wrongPOI);

		// tlacitka
		const buttonBar = node("div", { className: "ui-alternativePoiDialog__buttonBar" });
		const backButton = createDialogButton({ innerHTML: _("back") });

		backButton.setAttribute("data-log-ignore", "true");
		backButton.addEventListener("click", () => {
			this._onClose && this._onClose();
		});
		buttonBar.appendChild(backButton);

		const doneButton = createDialogButton({ innerHTML: _("done"), primary: true, disabled: true });

		doneButton.setAttribute("data-log-ignore", "true");
		doneButton.addEventListener("click", () => {
			this._onPOISelect && this._onPOISelect(this._selectedPOI);
		});
		buttonBar.appendChild(doneButton);
		this._dialog.dom.content.appendChild(buttonBar);

		try {
			const response = await fetchAlternativePOIs(this._event.id);

			if (response?.status === 200) {
				const json = await response.json() as IAlternativePOIResponse;

				if (json?.poi?.length) {
					// zobraz alternativy
					const list = node("ul", { className: "ui-alternativePoiDialog__list" });
					const srItems = json?.structured_rating || [];

					json.poi.forEach((poi, ind) => {
						const item = new POISelectItem({
							typeId: poi.typeId,
							title: poi.titleVars.titleSmartMain,
							subtitle: poi.titleVars.locationMain1,
						});
						const structuredRating = srItems[ind]?.structured_rating || [];

						item.node.addEventListener("click", () => {
							this._selectItems.forEach(aItem => {
								if (item !== aItem) {
									aItem.selected = false;
								}
							});
							item.selected = true;
							doneButton.disabled = false;

							if (poi.review) {
								// eslint-disable-next-line camelcase
								poi.review.structured_rating = structuredRating;
							}

							this._selectedPOI = poi;
						});

						this._selectItems.push(item);
						list.appendChild(item.node);
					});

					loader.replaceWith(list);
				} else {
					throw Error("jsme na konci");
				}
			} else {
				throw Error("nejsou data");
			}
		} catch (ex) {
			// eslint-disable-next-line no-console
			console.log(ex);
			loader.remove();
			// TODO: neni jasne, co delat, kdyz se to nenacte
		} finally {
			Mapy.getComponent("loader").end();
		}
	}

	close() {
		this._dialog.close();
	}
}
